import '../css/SpiralMenu.css';
import { useNavigation } from '../function/navigation';

function ProductMenu({ inputs, options, productMenuWarning }) {
  const { nav, dispatch } = useNavigation();

  const menuItems = [
    {
      id: 'pdp',
      customContent: {
        text: `${inputs.number_pdp}/${inputs.pdp.length} PDP`,
      },
      label: 'Predefined product',
      hidden: !inputs.pdp?.length,
    },
    {
      id: 'product',
      icon: 'product.png',
      label: 'Product tester',
      hidden: !options?.some((opt) => opt.field === 'product_tbh'),
    },
  ].filter((item) => !item.hidden);

  const handleItemClick = (itemId) => {
    dispatch({ type: 'productCurrentPage', payload: { menu: itemId } });
  };

  return (
    <div className="product-menu">
      {menuItems.map((item) => (
        <div
          key={item.id}
          className={[
            'product-menu-item',
            nav.productCurrentPage.menu === item.id ? 'active' : '',
            productMenuWarning[item.id] ? 'warning' : '',
          ].join(' ')}
          onClick={() => handleItemClick(item.id)}
        >
          {item.icon ? (
            <img
              src={`${process.env.PUBLIC_URL}/icons/${item.icon}`}
              alt={item.label}
              className="product-menu-icon"
            />
          ) : (
            <div className="product-menu-custom-content">
              {item.customContent.text}
            </div>
          )}
          <span className="product-menu-text">{item.label}</span>
        </div>
      ))}
    </div>
  );
}

export default ProductMenu;
